import { Injectable } from '@angular/core';
import { Helpers } from './helpers';
import { Configuration } from './configuration';
import { HttpClient, HttpHeaders, HttpParams, HttpHandler } from '@angular/common/http';

@Injectable()
export class GlobalHttpClient extends HttpClient {
    constructor(private readonly helpers: Helpers, handler: HttpHandler, private readonly configuration: Configuration) {
        super(handler);
    }

    getWithParams<T>(url: string, params: any, options?: {
        headers?: HttpHeaders;
        observe?: 'body';
        params?: HttpParams;
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }) {
        url = `${url}?${this.helpers.uriEncode(params)}`;

        return this.get<T>(url, options);
    }

    deleteWithParams<T>(url: string, params: any, options?: {
        headers?: HttpHeaders;
        observe?: 'body';
        params?: HttpParams;
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }) {
        url = `${url}?${this.helpers.uriEncode(params)}`;

        return this.delete<T>(url, options);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/global.http.client.ts